import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getLiveProgress } from 'helpers/Live';

import Style from './ProgressBar.module.scss';

const ProgressBar = ({ episode = {} }) => {
  const [progress, setProgress] = useState(null);
  const [liveInterval, setLiveInterval] = useState(null);

  const { percentWatched, startDate, endDate } = episode;
  useEffect(() => {
    const setLiveProgress = () => {
      const liveProgress = getLiveProgress({ startDate, endDate });
      const programEnded = !liveProgress || (liveProgress && liveProgress >= 100);
      const shouldClearInterval = liveInterval && programEnded;
      if (shouldClearInterval) {
        clearInterval(liveInterval);
        setLiveInterval(null);
      }
      return setProgress(liveProgress);
    };

    const liveProgress = getLiveProgress({ startDate, endDate });
    if (!percentWatched && liveProgress) {
      setLiveInterval(
        setInterval(() => {
          setLiveProgress();
        }, 60000),
      );
      setProgress(liveProgress);
      return () => setLiveInterval(null);
    }
    return () => {};
  }, []);

  if ((!percentWatched || percentWatched < 10) && !progress) return null;
  const currentProgress = progress || percentWatched;
  return (
    <div className={Style.progressBar}>
      <div className={Style.completed} style={{ width: `${currentProgress}%` }} />
    </div>
  );
};

ProgressBar.propTypes = {
  episode: PropTypes.shape({}),
};

export default ProgressBar;
